"use strict";

import React from "react";
import PropTypes from "prop-types";
import Head from "next/head";
import { translate } from "react-i18next";

import "bootstrap/scss/bootstrap.scss";
import "./../../assets/sass/app.scss";

class MyHead extends React.Component {
  getOgLocaleValue(locale) {
    switch (locale) {
      case "it":
        return "it_IT";
      default:
      case "en": {
        return "en_EN";
      }
    }
  }

  render() {
    const {
      t,
      canonical = process.env.SITE_CANONICAL_URL,
      locale = process.env.DEFAULT_LANG,
    } = this.props;
    const title = t("TITLE");
    const logoImage = "/static/image/logo-placeholder.png";

    return (
      <Head>
        <title>{title}</title>
        <meta name="author" content={t("AUTHOR")} />
        <meta name="robots" content="NOINDEX,NOFOLLOW" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />

        {/* --- Favicon --- */}
        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/static/image/favicon/neeru/apple-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href="/static/image/favicon/neeru/apple-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/static/image/favicon/neeru/apple-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/static/image/favicon/neeru/apple-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/static/image/favicon/neeru/apple-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/static/image/favicon/neeru/apple-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/static/image/favicon/neeru/apple-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/static/image/favicon/neeru/apple-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/static/image/favicon/neeru/apple-icon-180x180.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href="/static/image/favicon/neeru/android-icon-192x192.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/static/image/favicon/neeru/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href="/static/image/favicon/neeru/favicon-96x96.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/static/image/favicon/neeru/favicon-16x16.png"
        />
        <link rel="manifest" href="/static/image/favicon/neeru/manifest.json" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta
          name="msapplication-TileImage"
          content="/static/image/favicon/ms-icon-144x144.png"
        />
        <meta name="theme-color" content="#ffffff" />

        <meta name="og:title" content={title} />
        <meta name="og:image" content={logoImage} />
        <meta property="og:locale" content={this.getOgLocaleValue(locale)} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content={logoImage} />
        <meta name="twitter:card" content="summary" />

        {/* --- Fonts --- */}
        <link
          href="https://fonts.googleapis.com/css?family=Poppins:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i"
          rel="stylesheet"
        />
        <link href="/static/fonts/stylesheet.css" rel="stylesheet" />

        {/* --- Font awesome --- */}
        <script
          defer
          src="https://use.fontawesome.com/releases/v5.0.6/js/all.js"
        ></script>

        {/* --- animate --- */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"
        />
      </Head>
    );
  }
}

MyHead.propTypes = {
  canonical: PropTypes.string,
};

export default translate(["common"])(MyHead);



// WEBPACK FOOTER //
// src/components/MyHead.js